define('modules/header/navigation',[
	'app',
	'jquery',
	'backbone'
],
function(app, $, Backbone) {

	return Backbone.View.extend({
		el: '.js-main-navigation-container',
		mobileMode: false,
		currentHover: false,

		initialize: function(params){
			_.bindAll(
				this,
				'toggleDisplay',
				'toggleSubNavigation',
				'displaySubNavigation',
				'closeSubNavigation',
				'returnComponentState',
				'toggleSearch',
				'toggleSearchOverlay'
			);
			

			this.$el = $(this.el);

			$('.js-mobile-menu-toggle').on('click.navigation', this.toggleDisplay);
			$('.js-mobile-menu-close').on('click.navigation', this.toggleDisplay);


			var navigationItems = this.$el.find('.nav-main__item');
			$('.js-mobile-search-toggle').on('click.navigation', this.toggleSearch);
			$('.js-component-navigation-search-close').on('click.navigation', this.closeSearch);

			if (!$('html').hasClass('touch')){
				navigationItems.on('mouseenter.navigation', this.displaySubNavigation);
				navigationItems.on('mouseleave.navigation', this.closeSubNavigation);
			} else {
				this.mobileMode = true;
				navigationItems.on('click.navigation', this.toggleSubNavigation);
			}
		},

		returnComponentState: function(el) {
			if (el.hasClass('state--active')) {
				return true;
			}

			return false;
		},

		toggleDisplay: function(e) {
			if (this.$el.hasClass('is--active')) {
				this.$el.removeClass('is--active');
			} else {
				this.$el.addClass('is--animating');
				this.$el.addClass('is--active');
				$('body').scrollTop(0);
			}
		},

		toggleSubNavigation: function(e) {
			if (this.returnComponentState($(e.currentTarget))) {
				this.closeSubNavigation(e);
			} else {
				this.displaySubNavigation(e);
			}
		},

		displaySubNavigation: function(e) {
			this.closeSearch();
			var currentNavigationItem = $(e.currentTarget);

			currentNavigationItem.addClass(this.mobileMode ? 'state--active' : 'state--hover');

			if (this.currentHover !== currentNavigationItem) {
				this.currentHover = currentNavigationItem;
				var currentNavigationSubmenu = currentNavigationItem.find('.menu-attach-block-wrapper');

				if (currentNavigationSubmenu) {
					TweenLite.set(currentNavigationSubmenu, {height: 'auto'});
					TweenLite.from(currentNavigationSubmenu, 0.3, {height: 0});
				}
			}
		},

		closeSubNavigation: function(e) {
			var currentNavigationItem = $(e.currentTarget);

			var currentNavigationSubmenu = currentNavigationItem.find('.menu-attach-block-wrapper');

			if (currentNavigationSubmenu) {
				TweenLite.to(currentNavigationSubmenu, 0.3, {height: 0});
			}

			currentNavigationItem.removeClass(this.mobileMode ? 'state--active' : 'state--hover');
		},

		toggleSearch: function(e) {
			e.preventDefault();
			var searchBtnEl = $('.js-mobile-search-toggle');
			var searchOpen = searchBtnEl.hasClass('search-active');
			var searchContent = $(".js-component-navigation-search-container");

			if (searchOpen) {
				this.closeSearch();
			} else {
				TweenLite.set(searchContent, {height: "auto"});

	            TweenLite.from(
	                searchContent, 0.15, {
	                height: '0',
	                ease: Power1.easeOut,
	                onStart: function() {
	                    searchBtnEl.addClass('search-active');
	                },
	                onComplete: function() {
	                    searchContent.addClass('state--open');
	                }
	            });
			}
		},

		closeSearch: function(e) {
			e = e || false;
			if (e) {
				e.preventDefault();
			}
			var searchBtnEl = $('.js-mobile-search-toggle');
			var searchContent = $(".js-component-navigation-search-container");

			TweenLite.to(searchContent, 0.15, {
                height: '0',
                ease: Power1.easeIn,
                onStart: function() {
                    searchBtnEl.removeClass('search-active');
                    searchContent.removeClass('state--open');
                }
            });
		},

		toggleSearchOverlay: function(el) {
			var overlayContainer = $(el.find('.js-search-block-component-overlay'));

			if (this.returnComponentState(overlayContainer)) {
				overlayContainer.removeClass('state--active');
				overlayContainer.off('click.navigation');
			} else {
				overlayContainer.addClass('state--active');
				overlayContainer.on('click.navigation', this.toggleSearch);
			}
		},
	});
});

